import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Form } from "react-bootstrap";
import { useAuth } from "../../context/AuthContext";
import { useAlert } from "../../context/AlertContext";
import { useLoading } from "../../context/LoadingContext";
import { getServiceRequest } from "../../commons/ServiceRequest";
import { initializeSetOptionMulti } from "../../utils/InitializeSetDefault";
import TableForm from "../TableForm";
import ConfirmModal from "../ConfirmModal";
import ItemsService from "../../services/item.service";
import CardDisplayComponent from "../CardDisplayComponent";

const SetMachineTypeForm = ({ editData, onSubmitCallback }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const [showModal, setShowModal] = useState(false);
  const [validated, setValidated] = useState(false);
  const [itemMas, setItemMas] = useState([]);
  const defaultData = { Item_Id: "", MC_Type: "", Com_Code: user.Com_Code };
  const [data, setData] = useState({ Array: [defaultData] });
  const inputField = [
    {
      name: "Item_Id",
      label: "รหัสสินค้า",
      type: "select",
      disabled: !!editData,
      filterBy: ["Item_Code", "Item_Name_TH"],
      options: initializeSetOptionMulti({
        key: "Id",
        label: ["Item_Code", "Item_Name_TH"],
        dataset: itemMas
      }),
      queryService: (query) =>
        getServiceRequest({
          showAlert,
          setLoading,
          serviceRequest: ItemsService.getAllItems(query),
          callback: ({ items }) => setItemMas(items)
        })
    },
    {
      name: "Item_Name_TH",
      label: "รายละเอียดสินค้า",
      type: "text",
      findValue: { data: itemMas, key: "Id", value: "Item_Id" },
      readOnly: true
    },
    {
      name: "MC_Type",
      label: "Machine Type",
      type: "text",
      size: 2,
      pattern: /^(?!.*[^\w]).{1,50}$/.source,
      feedbackMessage:
        "ข้อมูลไม่ถูกต้อง โปรดใช้เฉพาะตัวอักษรตัวพิมพ์ใหญ่หรือตัวเลข และห้ามเป็นค่าว่างหรือเว้นวรรค (สูงสุด {number} ตัวอักษร)"
    }
  ];

  const handleValidated = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (!form.checkValidity()) {
      event.stopPropagation();
      setValidated(true);
    } else {
      setShowModal(true);
    }
  };

  const handleSubmit = (event, { dataCallback, showCallback }) => {
    event.preventDefault();
    setShowModal(showCallback);

    if (dataCallback) {
      if (!editData) onSubmitCallback(dataCallback);
      else onSubmitCallback(dataCallback.Array[0]);
    }
  };

  useEffect(() => {
    if (editData) {
      getServiceRequest({
        showAlert,
        setLoading,
        serviceRequest: ItemsService.getItems(editData.Item_Id),
        callback: (response) => setItemMas([response])
      });

      setData({
        Array: [
          {
            Item_Id: editData.Item_Id,
            MC_Type: editData.MC_Type,
            Com_Code: editData.Com_Code
          }
        ]
      });
    }
  }, [editData]);

  return (
    <>
      <Form noValidate validated={validated} onSubmit={handleValidated}>
        <CardDisplayComponent
          header={{
            title: { text: `${editData ? "แก้ไข" : "เพิ่ม"} MC Type` }
          }}
          body={{
            element: (
              <TableForm
                data={data.Array}
                columns={inputField}
                editForm={!!editData}
                defaultData={defaultData}
                onChangeCallback={(newData) => setData({ Array: newData })}
              />
            )
          }}
          footer={{
            className: "text-end",
            element: (
              <>
                <Button
                  type="submit"
                  variant="success"
                  className="me-2 px-5 py-2 text-dark rounded-pill"
                >
                  {editData ? "บันทึกการแก้ไข" : "บันทึกข้อมูล"}
                </Button>
                <ConfirmModal
                  data={data}
                  show={showModal}
                  content={editData ? "edit" : "save"}
                  onSubmitCallback={handleSubmit}
                />

                <Button
                  variant="outline-success"
                  className="px-5 py-2 text-dark border-dark border-opacity-50 rounded-pill"
                  onClick={() => navigate(-1)}
                >
                  ยกเลิก
                </Button>
              </>
            )
          }}
        />
      </Form>
    </>
  );
};

SetMachineTypeForm.propTypes = {
  editData: PropTypes.object,
  onSubmitCallback: PropTypes.func
};

export default SetMachineTypeForm;
